(function () {

    module.exports = {
        prepareDocumentList,
        prepareSingleDocument,
        generateUniqueId,
    };

    let _ = require('lodash');

    function prepareDocumentList(documentsResult) {
        const documentsList = [];

        _.forEach(documentsResult.docs, (document) => {
            const documentDetail = prepareSingleDocument(document);

            if (!_.isEmpty(documentDetail)) {
                documentsList.push(documentDetail);
            }
        });

        return documentsList;
    }

    function prepareSingleDocument(documentResult) {
        let documentDetail = {};

        if (!documentResult.exists) {
            return documentDetail;
        }

        documentDetail = {
            ...documentResult.data(),
            id: documentResult.id,
        };

        return documentDetail;
    }

    function generateUniqueId() {
        const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        const idLength = 20;

        let uniqueId = '';
        for (let i = 0; i < idLength; i++) {
            const randomIndex = Math.floor(Math.random() * characters.length);
            uniqueId += characters.charAt(randomIndex);
        }

        return uniqueId;
    }

})();
